import {
  myptmActivationFile,
  myptmActivationFormatDownload,
  myptmActivationLinkAjaDownload,
  myptmActivationList,
  myptmActivationManual,
  myptmActivationProcess,
  settingMerchantDetail
} from '../../utils/api';
import { filterBuilder } from '../../utils/builder/aktivasiMyPertamina';
import { actionTypes } from './constants';
import { initialState } from './reducer';

const { FAILED, FILTER, LOADING, MESSAGE, SUCCESS } = actionTypes;

export function setFailedAction({ key, message }) {
  return { type: FAILED, key, message };
}

export function setLoadingAction({ key, loading = true, message = '' }) {
  return { type: LOADING, key, loading, message };
}

export function setSuccessAction({
  key,
  data,
  meta = {},
  initial = true,
  message = '',
}) {
  return { type: SUCCESS, key, data, meta, initial, message };
}

export function setFilterAction({ key, filter = {} }) {
  return { type: FILTER, key, filter };
}

export function setMessageAction({ key, message }) {
  return { type: MESSAGE, key, message };
}

export function fetchMyptmActivationList({
  nextPage = 1,
  search = '',
  filter = initialState.table.filter,
  initial = true,
  key = 'table',
}) {
  return async (dispatch, getState) => {

    const state = getState();
    const { page, totalPage } = state.myptmActivation[key].meta;
    if (!initial && page > 1 && page >= totalPage) {
      return;
    }
    try {
      dispatch(setLoadingAction({ key }));
      const params = {
        ...filter,
        search,
        size: 100,
        page: nextPage,
      };
      const { data, meta } = await myptmActivationList(filterBuilder(params));
      dispatch(setSuccessAction({ key, data, meta, initial }));
    } catch (error) {
      dispatch(setFailedAction({ key, message: error && error.message ? error.message : '' }));
    }
  };
}

export function getExportedLinkAjaMyptmActivation(userId = []) {
  return async (dispatch) => {
    const key = 'download';
    try {
      dispatch(
        setLoadingAction({
          key,
          message: 'Sedang mengunduh data, mohon tunggu...',
        })
      );
      const process = await myptmActivationProcess({ userId });
      if (process.success) {
        const { data } = await myptmActivationLinkAjaDownload({
          userId: JSON.stringify(userId),
        });
        if (data.fileUrl) {
          dispatch(
            setSuccessAction({
              key,
              data,
              message: `Berhasil mengunduh ${userId.length} data Pangkalan LPG 3 Kg.`,
            })
          );
          window.open(data.fileUrl, '_blank');
        }
      }
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function getExportedFormatMyptmActivation(userId = []) {
  return async (dispatch) => {
    const key = 'download';
    try {
      dispatch(
        setLoadingAction({
          key,
          message: 'Sedang mengunduh data, mohon tunggu...',
        })
      );
      const process = await myptmActivationProcess({ userId });
      if (process.success) {
        const { data } = await myptmActivationFormatDownload({
          userId: JSON.stringify(userId),
        });
        if (data.fileUrl) {
          dispatch(
            setSuccessAction({
              key,
              data,
              message: `Berhasil mengunduh format file Aktivasi MyPertamina`,
            })
          );
          window.open(data.fileUrl, '_blank');
        }
      }
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function setMyptmActivationListFilter(filter) {
  return async (dispatch) => {
    dispatch(
      setFilterAction({
        key: 'table',
        filter,
      })
    );
  };
}

export function activateMyptmManualActivation(activations = []) {
  return async (dispatch) => {
    const key = 'activation';
    const userId = activations.map((item) => item.userId);
    try {
      dispatch(
        setLoadingAction({
          key,
          message: 'Sedang melakukan proses aktivasi, mohon tunggu...',
        })
      );
      const process = await myptmActivationProcess({ userId });
      if (process.success) {
        const { data } = await myptmActivationManual({ activations });
        dispatch(
          setSuccessAction({
            key,
            data,
            message: 'Aktivasi pembayaran MyPertamina berhasil',
          })
        );
      }
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}

export function activateMyptmFileActivation(file) {
  return async (dispatch) => {
    const key = 'activation';
    try {
      dispatch(
        setLoadingAction({
          key,
          message: 'Sedang melakukan proses aktivasi, mohon tunggu...',
        })
      );
      const { data } = await myptmActivationFile(file);
      dispatch(
        setSuccessAction({
          key,
          data,
          message: 'Aktivasi pembayaran MyPertamina berhasil',
        })
      );
    } catch (error) {
      const { message } = error;
      let actualMessage = message;
      if (typeof message !== 'string') {
        window.open(message.link, '_blank');
        actualMessage =
          'File yang diunggah memiliki kekurangan data, <br> segera periksa data dan unggah kembali.';
      }
      dispatch( setFailedAction({ key, message: actualMessage }));
    }
  };
}

export function fetchActivatedMerchantDetail(id = '') {
  return async (dispatch) => {
    const key = 'detail';

    try {
      dispatch(setLoadingAction({ key }));
      const { data } = await settingMerchantDetail(id, false);
      dispatch(setSuccessAction({ key, data }));
    } catch (error) {
      const { message } = error;
      dispatch(setFailedAction({ key, message }));
    }
  };
}
